import { makeStyles, Tooltip, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { getCurrentNetwork } from "src/configs/connection-config";
import { ExternalLink } from "../icons";

const useStyles = makeStyles(() => ({
  viewOnBSCLink: {
    color: "inherit",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  tooltip: {
    maxWidth: "none",
  },
}));

function ViewAccountAddressOnBSC({ address, ...rest }) {
  const cls = useStyles();
  const { blockExplorerUrls } = getCurrentNetwork();

  return (
    <Typography {...rest}>
      <Tooltip title={"View account on BSC Explorer"} placement="top" arrow interactive cls={{ tooltip: cls.tooltip }}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={cls.viewOnBSCLink}
          href={`${blockExplorerUrls}/address/${address}`}
        >
          <ExternalLink size={14} />
        </a>
      </Tooltip>
    </Typography>
  );
}

export default ViewAccountAddressOnBSC;

ViewAccountAddressOnBSC.propTypes = {
  address: PropTypes.string.isRequired,
};

ViewAccountAddressOnBSC.defaultProps = {
  variant: "body2",
  gutterBottom: false,
};
